import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Filter from './Filter';
import { findFirstTeachers, findNextTeachers, filterTeacher } from '../../../../firebase'

export default function TutorService() {
    const [tutors, setTutors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [more, setMore] = useState(false)

    useEffect(() => {
        setLoading(true);
        findFirstTeachers().then(res => {
            setLoading(false);
            setTutors(res);
            if (res.length < 25) {
                setMore(false);
            }else{
                setMore(true);
            }
        }).catch(e => {
            console.log(e);
            setLoading(false);
        });
    }, [])

    const getMore = () =>{
        setLoading(true);
        findNextTeachers().then(res => {
            setLoading(false);
            setTutors(pre=>([...pre,res]));
            if (res.length < 25) {
                setMore(false);
            }else{
                setMore(true);
            }
            console.log(res);
        }).catch(e => {
            console.log(e);
            setLoading(false);
        });
    }

    const filterSearch = (teachDetails) =>{
        setLoading(true);
        filterTeacher(teachDetails).then(res=>{
            setLoading(false);
            setTutors(res);
        }).catch(e=>{
            console.log(e);
            setLoading(false);
        })
    }

    return (
        <section id="services" className="services section-bg">
            <div className="container">
                <div className="section-title">
                    <h2>Home Tutor</h2>
                    <Filter filterSearch={filterSearch}/><p></p>
                </div>
                <div className="row team gy-2">
                {loading && <><h2>Loading</h2>
                        <div className="d-flex justify-content-center" style={{ color: "#eb5d1e" }}>

                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div></>}

                    {!loading && tutors.length > 0 ? tutors.map((t, index) => <div key={index} className="col-6 col-sm-3" data-aos="zoom-in" data-aos-delay={100}>
                    <Link to={`/profile/${t.id}`}>
                        <div className="card h-100">
                            <div className="card-body h-100">
                            <img className="card-img-top" src={t.pic} alt="Card cap" height="200px"/>
                                    <div className="card-info-content p-2 h-100">
                                        <div className='row'>
                                            <div className='col-12 col-md-6'>
                                            <h4>{t.name}</h4>
                                            <span>Home Tutor</span>
                                            </div>
                                            <div className='col-12 col-md-6'>
                                            <span>{t.district}</span>
                                            {t.review && <span >
                                                {[...new Array(t.review)].map((r, index) => <i style={{ color: "#eb5d1e" }} key={index} className="bx bxs-star"></i>)}
                                                {[...new Array(5 - t.review)].map((r, index) => <i key={index} className="bx bx-star"></i>)}
                                            </span>}
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        </Link>
                    </div>):!loading &&<h2>No data found</h2>}
                    {more && <div className="col-12">
                        <button className="btn btn-sm btn-secondary" onClick={getMore}>More</button>
                    </div>}
                </div>
            </div>
        </section>

    );
}